import React from "react";
import { MapPin, ExternalLink, MessageCircle } from "lucide-react";
import { SITE, OUTLETS } from "@/data/site";
import { Gonjong } from "@/components/Gonjong";

const Lokasi = () => (
  <main data-testid="lokasi-page">
    <section className="relative bg-ink text-rice">
      <div className="mx-auto max-w-6xl px-4 pb-20 pt-16 sm:px-6 sm:pt-20">
        <p className="text-sm font-bold uppercase tracking-[0.22em] text-kunyit">
          Lokasi & Outlet
        </p>
        <h1
          data-testid="lokasi-h1"
          className="mt-3 max-w-2xl font-display text-4xl font-black leading-tight sm:text-5xl"
        >
          Temukan outlet RM. Payakumbuah terdekat
        </h1>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-rice/85 sm:text-lg">
          Kami hadir di Jabodetabek, Bandung, dan Semarang — dan terus
          bertumbuh.
        </p>
      </div>
      <div className="absolute bottom-0 left-0 right-0 text-rice">
        <Gonjong />
      </div>
    </section>

    <section className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-20">
      <ul
        className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3"
        data-testid="outlet-list"
      >
        {OUTLETS.map((o) => (
          <li
            key={o.name}
            className="rounded-2xl border border-ink/10 bg-card p-6 transition-shadow hover:shadow-lg"
          >
            <MapPin className="h-6 w-6 text-lado" aria-hidden="true" />
            <h2 className="mt-3 font-display text-lg font-bold text-ink">
              {o.name}
            </h2>
            <p className="mt-1 text-sm font-semibold text-ijo">{o.city}</p>
          </li>
        ))}
      </ul>

      <div className="mt-14 grid gap-6 md:grid-cols-2">
        <div className="rounded-2xl bg-secondary/60 p-7 sm:p-9">
          <h2 className="font-display text-2xl font-bold">Peta Seluruh Outlet</h2>
          <p className="mt-3 text-sm leading-relaxed text-ink/75 sm:text-base">
            Lihat sebaran seluruh outlet {SITE.name} pada peta resmi kami di
            Google Maps, lengkap dengan petunjuk arah ke masing-masing lokasi.
          </p>
          <a
            href={SITE.maps}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="lokasi-maps-cta"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-lado px-6 py-3 text-base font-bold text-rice transition-transform hover:-translate-y-0.5"
          >
            <ExternalLink className="h-5 w-5" aria-hidden="true" />
            Buka Peta Outlet
          </a>
        </div>
        <div className="rounded-2xl border border-ink/10 bg-card p-7 sm:p-9">
          <h2 className="font-display text-2xl font-bold">Kantor</h2>
          <p className="mt-3 text-sm font-semibold text-ink/60">{SITE.company}</p>
          <p className="mt-2 text-base leading-relaxed text-ink/80">{SITE.address}</p>
          <p className="mt-4 text-sm leading-relaxed text-ink/70">
            Jam operasional berbeda di tiap outlet. Cek jam buka outlet tujuan
            Anda melalui GoFood, atau tanyakan langsung kepada kami.
          </p>
          <a
            href={SITE.wa.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="lokasi-wa-cta"
            className="mt-6 inline-flex items-center gap-2 rounded-full border-2 border-ijo px-6 py-3 text-base font-bold text-ijo transition-colors hover:bg-ijo hover:text-rice"
          >
            <MessageCircle className="h-5 w-5" aria-hidden="true" />
            Tanya via WhatsApp
          </a>
        </div>
      </div>
    </section>
  </main>
);

export default Lokasi;
